import React from 'react';
import { Link } from 'react-router-dom';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { modelClass } from '/imports/api/primeRates';
import { formatDateTime } from '/imports/utils';
import { useUser } from '/imports/hooks';

/** Lists prime rate records with date, rate, and timestamp columns. */
export const PrimeRatesPage = () => {
  const user = useUser();
  return <ModelListPage
    permission={() => !!user?.isSuperUser}
    modelClass={modelClass}
    columns={[
      { field: 'date', render: (doc) => <Link to={`${modelClass.pathPrefix}/${doc._id}`}>{doc.date}</Link> },
      { field: 'rate', },
      { field: 'createdAt', render: (doc) => <span>{doc.createdAt && formatDateTime(doc.createdAt)}</span> },
      { field: 'updatedAt', render: (doc) => <span>{doc.updatedAt && formatDateTime(doc.updatedAt)}</span> },
    ]}
    defaultSort={{ date: -1 }}
  />;
};